// Service plan section questionnaire constants
// Extract relevant constants from main questionnaire enum
export enum ServicePlanQuestionnaireItem {
  SERVICE_PLAN = 'service-plan',
  SERVICE_PLAN_PATIENT_TASKS = 'service-plan/patient-tasks',
  SERVICE_PLAN_PATIENT_TASKS_TASK_INFO = 'service-plan/patient-tasks/task-info',
  SERVICE_PLAN_PATIENT_TASKS_TASK_INFO_ID = 'service-plan/patient-tasks/task-info/id',
  SERVICE_PLAN_PATIENT_TASKS_TASK_INFO_ADL = 'service-plan/patient-tasks/task-info/adl',
  SERVICE_PLAN_PATIENT_TASKS_TASK_INFO_SERVICE_TYPE = 'service-plan/patient-tasks/task-info/service-type',
  SERVICE_PLAN_PATIENT_TASKS_TASK_INFO_DIRECTIONS = 'service-plan/patient-tasks/task-info/directions',
  SERVICE_PLAN_PATIENT_TASKS_TASK_INFO_FREQUENCY = 'service-plan/patient-tasks/task-info/frequency'
}
